<div class="shipping-view-container">
  <!-- Shipping Address Section -->
  @if (order()) {
    <mat-card-header>
      <mat-card-title class="text-lg font-semibold text-primary">Shipping Address:</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="py-8 grid grid-cols-2 gap-8 items-center">
        <div class="flex flex-col gap-4">
          <div class="field-row">
            <div class="grid grid-cols-2 gap-4 w-full">
              <div class="flex justify-end items-center">
                <span class="field-label text-right w-full">Street Address 1:</span>
              </div>
              <div class="flex justify-start items-center">
                <span class="field-value w-full">{{
                  order()?.shippingDetails?.[0]?.address1Street || 'Sos. Bucium nr. 53'
                }}</span>
              </div>
            </div>

            <div class="grid grid-cols-2 gap-4 w-full">
              <div class="flex justify-end items-center">
                <span class="field-label text-right w-full">City:</span>
              </div>
              <div class="flex justify-start items-center">
                <span class="field-value w-full">{{
                  order()?.shippingDetails?.[0]?.address1City || 'Iasi'
                }}</span>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-4 w-full">
              <div class="flex justify-end items-center">
                <span class="field-label text-right w-full">Zip:</span>
              </div>
              <div class="flex justify-start items-center">
                <span class="field-value w-full">{{
                  order()?.shippingDetails?.[0]?.address1Zip || '700280'
                }}</span>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-4 w-full">
              <div class="flex justify-end items-center">
                <span class="field-label text-right w-full">Country:</span>
              </div>
              <div class="flex justify-start items-center">
                <span class="field-value w-full">{{
                  order()?.shippingDetails?.[0]?.address1Country || 'Romania'
                }}</span>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-4 w-full">
              <div class="flex justify-end items-center">
                <span class="field-label text-right w-full">State/Province:</span>
              </div>
              <div class="flex justify-start items-center">
                <span class="field-value w-full">{{
                  order()?.shippingDetails?.[0]?.address1State || 'Iasi'
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="grid grid-cols-2 gap-4 w-full mb-4">
            <div class="flex justify-end items-center">
              <span class="field-label">ATTN / Dept:</span>
            </div>
            <div class="flex justify-start items-center">
              <span class="field-value">{{ order()?.shippingDetails?.[0]?.attn || '-' }}</span>
            </div>
          </div>
          <span class="field-label">Shipping Note:</span>
          <div class="mt-2 p-3 bg-gray-50 rounded">
            <input
              class="field-value w-full bg-transparent border-none outline-none"
              type="text"
              [value]="order()?.shippingDetails?.[0]?.shippingNotes || 'N/A'"
              readonly
            />
          </div>
        </div>
      </div>
    </mat-card-content>

    <!-- Shipments Section (repeater) -->
    @for (shipment of order()?.shipments ?? []; track $index; let i = $index) {
      <mat-card-header>
        <mat-card-title class="text-lg font-semibold text-primary"
          >Shipment {{ i + 1 }}:</mat-card-title
        >
      </mat-card-header>
      <mat-card-content>
        <div class="py-8 grid grid-cols-2 gap-8 items-start">
          <div class="flex flex-col gap-4">
            <div class="field-row">
              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Shipping Method:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.shippingMethod || '-' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Tracking Number:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.trackingNumber || '-' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Units Available To Ship:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{
                    shipment?.unitsAvailableToShip || '2'
                  }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Units To Ship:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.units || '-' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Total Price:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.totalPrice || '1188' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Weight:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.weight || '-' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Date Shipped:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{
                    shipment?.dateShipped | date: 'MM/dd/yyyy'
                  }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Quickbooks Invoice:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.quickbooksInvoice || '-' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Shipment Photo:</span>
                </div>
                <div class="flex justify-start items-center">
                  <a
                    mat-flat-button
                    color="accent"
                    *ngIf="shipment?.shipmentPhotoUrl"
                    href="{{ shipment.shipmentPhotoUrl }}"
                    target="_blank"
                  >
                    VIEW
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-4">
            <div class="field-row">
              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Drop Ship Address:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.dropShipAddress || '-' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Street Address 2:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.dropStreetAddress2 || '-' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">City:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.dropCity || '-' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Zip:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.dropZip || '-' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Country:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.dropCountry || '-' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">State:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.dropState || '-' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">ATTN / Dept:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.dropAttn || '-' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Drop Ship Box:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.dropShipBox || '-' }}</span>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Drop Shipment Attachment:</span>
                </div>
                <div class="flex justify-start items-center">
                  <a
                    mat-flat-button
                    color="accent"
                    *ngIf="shipment?.dropShipAttachmentUrl"
                    href="{{ shipment.dropShipAttachmentUrl }}"
                    target="_blank"
                  >
                    VIEW
                  </a>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-4 w-full">
                <div class="flex justify-end items-center">
                  <span class="field-label text-right w-full">Packing Slip:</span>
                </div>
                <div class="flex justify-start items-center">
                  <span class="field-value w-full">{{ shipment?.packingSlip || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Shipping Notes Section for this shipment -->
        <div class="mt-4">
          <span class="field-label">Shipping Notes:</span>
          <div class="mt-2 p-3 bg-gray-50 rounded">
            <input
              class="field-value w-full bg-transparent border-none outline-none"
              type="text"
              [value]="shipment?.shippingNotes || 'N/A'"
              readonly
            />
          </div>
        </div>

        <!-- Documents (attachments) repeater -->
        @if ((shipment?.attachments?.length ?? 0) > 0) {
          <div class="mt-6">
            <span class="field-label">Attachments:</span>
            <div class="mt-2 flex flex-col gap-3">
              @for (att of shipment.attachments; track $index) {
                <div class="flex gap-4 items-center">
                  <div class="flex justify-start items-center">
                    <span class="field-value">{{ att?.attachmentName || '-' }}</span>
                  </div>
                  <div class="flex justify-start items-center">
                    <a
                      mat-flat-button
                      color="accent"
                      *ngIf="att?.url"
                      [href]="att?.url"
                      target="_blank"
                    >
                      VIEW
                    </a>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </mat-card-content>
    }
  }
</div>
